export const bookACallStepHeader = 'We want to get to know you';
export const bookACallStepDescription = 'Learn how to get the most out of your sessions, from the best';
export const bookACallStepFooter = 'Head of Customer Success';
export const bookACallStepMessage =
  'I’d love to meet you! Please book a call with me so I can learn about your music, discover your aspirations and answer any questions you might have.';

export const webinarMessage =
  'We’re hosting a Webinar where we’ll give you advice on how to make your best music yet, and get the most out of our roster & platform. It’s FREE and you’re hereby invited to attend :)\nSave your seat below!';
